<template>
  <div class="popup-wrap cookie-popup" :class="{ active: showCookie }">
    <div class="cookie-frame">
      <div>
        {{ $t("Bao.cookie_content") }}
      </div>
      <div class="cookie-btn-frame">
        <button type="button" class="btn btn-primary btn-policy btn-cookie-accept" @click="acceptCookie">
          {{ $t("Bao.cookie_accept") }}
        </button>
        <button type="button" class="btn btn-secondary btn-policy btn-cookie-decline" @click="declineCookie">
          {{ $t("Bao.cookie_decline") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieAgree',
  computed: {
    showCookie() {
      // 需求:cookie 彈窗等到玩家成為會員(已登入)後才跳,且尚未回應過(同意/不同意)時才顯示
      return this.$store.state.app.isNeedCookie &&
        !!this.$store.getters.token &&
        !this.$store.getters.cookieResponded
    }
  },
  methods: {
    acceptCookie() {
      this.setCookiePreference(true)
    },
    declineCookie() {
      this.setCookiePreference(false)
    },
    setCookiePreference(isAgree) {
      this.$store.commit('SET_IS_AGREE_COOKIE', isAgree)
      // 記住玩家已回應,之後不再詢問
      this.$store.commit('SET_COOKIE_RESPONDED', true)
      // 保存偏好一年(同意 true / 不同意 false)
      document.cookie = `isAgreeCookie=${isAgree}; path=/; max-age=31536000`
    }
  }
}
</script>
